import { useWriteAccess } from '@app/src/hooks/useWriteAccess'
import { ProviderPriority } from '@app/src/types/categories'
import { Add } from '@mui/icons-material'
import { Chip } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import type { ButtonCellProps } from './ButtonCell'
import ButtonCell from './ButtonCell'
import ParentCellOrFragment from './ParentCellOrFragment'
import ValueCell from './ValueCell'

type Props = {
  value?: ProviderPriority
  disableCell?: boolean
  onClick?: React.MouseEventHandler<HTMLDivElement | HTMLButtonElement>
  size?: ButtonCellProps['size']
}

const PriorityCell: React.FC<Props> = ({ value, disableCell, size, onClick }) => {
  const { formatMessage } = useIntl()
  const hasWriteAccess = useWriteAccess()

  if (value === ProviderPriority.NotSelected) {
    return onClick && hasWriteAccess ? (
      <ButtonCell
        label={formatMessage({ id: 'general.add' })}
        startIcon={<Add />}
        onClick={onClick}
        disableCell={disableCell}
        size={size}
      />
    ) : (
      <ValueCell
        value={formatMessage({ id: `schemas.provider.priorityValues.${value}` })}
        disableCell={disableCell}
        onClick={hasWriteAccess ? onClick : undefined}
      />
    )
  }

  return (
    <ParentCellOrFragment disableCell={disableCell}>
      <Chip
        clickable={Boolean(onClick) && hasWriteAccess}
        onClick={hasWriteAccess ? onClick : undefined}
        sx={{ bgcolor: 'white' }}
        variant="outlined"
        size="small"
        label={formatMessage({ id: `schemas.provider.priorityValues.${value}` })}
      />
    </ParentCellOrFragment>
  )
}

export default PriorityCell
